import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { URLS } from "./_config";
import requireNoAuth from "./_common/hoc/reqNoAuth";
import requireAuth from "./_common/hoc/reqAuth";
import reqLayout from "./_common/hoc/layout";
import Login from "./containers/login";
import MyProfile from "./containers/myProfile";
import RodeoEventContainer from "./containers/RodeoEvent/rodeoEvent";
import Page404 from "./containers/page-404";
import CacheBuster from "./CacheBuster";
import CmsContainer from "./containers/cms/cms";
import PrizesListContainer from "./containers/prizes-list/prizes-list";
import PrizeDetailsContainer from "./containers/prize/prize-details";
import RodeoEventPerformanceContainer from "./containers/RodeoEventPerformance/rodeoEventPerformance";
import RodeoEventTaskContainer from "./containers/RodeoEventTask/rodeoEventTask";
import RodeoEventLeaderBoardContainer from "./containers/rodeoLeaderBoard/event-specific/rodeoEventLeaderBoard";
import RodeoTvImageContainer from "./containers/tv-image/tv-image";
import RodeoEventTaskDetailsContainer from "./containers/RodeoEventTaskDetails/rodeoEventTaskDetails";
import LoginWithEmail from "./containers/loginWithEmail";
import Register from "./containers/register";
import ForgotPassword from "./containers/forgot-password";
import ResetPassword from "./containers/reset-password";

function App() {
  return (
    <CacheBuster>
      {({
        loading,
        isLatestVersion,
        refreshCacheAndReload,
      }: {
        loading: boolean;
        isLatestVersion: boolean;
        refreshCacheAndReload: () => void;
      }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <React.Fragment>
            <Router>
              <Switch>
                <Route exact path={URLS.HOME} component={RodeoEventContainer} />
                <Route exact path={URLS.USER.PROFILE} component={requireAuth(MyProfile)} />
                <Route exact path={URLS.EVENT.PERFORMANCES} component={reqLayout(RodeoEventPerformanceContainer)} />
                <Route exact path={URLS.EVENT.TASKS} component={reqLayout(RodeoEventTaskContainer)} />
                <Route exact path={URLS.EVENT.TASK_DETAILS} component={reqLayout(RodeoEventTaskDetailsContainer)} />
                <Route exact path={URLS.TV_IMAGE} component={RodeoTvImageContainer} />
                <Route
                  exact
                  path={URLS.EVENT.LEADER_BOARD.EVENT}
                  component={reqLayout(RodeoEventLeaderBoardContainer)}
                />
                <Route exact path={URLS.LOGIN} component={requireNoAuth(Login)} />
                <Route exact path={URLS.LOGIN_WITH_EMAIL} component={requireNoAuth(LoginWithEmail)} />
                <Route exact path={URLS.REGISTRATION} component={requireNoAuth(Register)} />
                <Route exact path={URLS.FORGOT_PASSWORD} component={requireNoAuth(ForgotPassword)} />
                <Route exact path={URLS.RESET_PASSWORD} component={requireNoAuth(ResetPassword)} />
                <Route exact path={URLS.EVENT.PRIZES_LIST} component={PrizesListContainer} />
                <Route exact path={URLS.EVENT.PRIZE} component={PrizeDetailsContainer} />
                <Route exact path={URLS.CMS.CMS} component={CmsContainer} />
                <Route path="*" component={reqLayout(Page404)} />
              </Switch>
            </Router>
          </React.Fragment>
        );
      }}
    </CacheBuster>
  );
}

export default App;
